import { render, staticRenderFns } from "./LoginStatus.vue?vue&type=template&id=533cc9ed&scoped=true&"
import script from "./LoginStatus.vue?vue&type=script&lang=js&"
export * from "./LoginStatus.vue?vue&type=script&lang=js&"
import style0 from "./LoginStatus.vue?vue&type=style&index=0&id=533cc9ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "533cc9ed",
  null
  
)

export default component.exports